import { atom } from 'jotai';

import type { CreditCardBrandInput } from '../CreditCard/creditcardTypes';

import type { BrandSurcharge } from './surchargeTypes';

export const surchargeAtom = atom<number>(0);

export const allSurchargesAtom = atom<BrandSurcharge[]>([]);

export const selectedCardBrandAtom = atom<CreditCardBrandInput>('UNKNOWN');
